import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-501">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-502">
        <CTASection headline="Need a Distributed File System?" body="Let's discuss your storage architecture and how GFS can support your high-availability requirements." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-503" />
      </div>
    </section>;
}